import httpClient from '@/libs/http-client'

export function validateTimezone (values) {
  const url = `/timezone/validate_timezone`

  return httpClient.post(url, values).then(response => {
    return response.data.result
  })
}
